module.exports = __webpack_public_path__ + "static/img_red-ribbon-9eae7e21a25fa0919f9c8a20c4638682.png";